<template>
	<div ref="LangCanvas" style="margin-top: -8%;width: 100%;height: 120%;overflow: hidden;"></div>
</template>

<script>
	// 在需要监听鼠标移动的地方加上id="Lang"
	import * as THREE from 'three';
	export default {
		data() {
			return {
				interval: '',
				timeout: ''
			}
		},
		computed: {
			langCanvasLoad() {
				return this.$store.state.langCanvasLoad || false
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.timeout = setTimeout(() => {
					this.init();
				}, 1000)
			})
		},
		unmounted() {
			this.remove();
		},
		methods: {
			remove() {
				clearInterval(this.interval);
				clearTimeout(this.timeout);
			},
			init() {
				var self = this;

				// var THREE = require('three');

				//密度 长 宽
				var SEPARATION = 50,
					AMOUNTX = 60,
					AMOUNTY = 55;

				var container;
				var camera, scene, renderer;

				var particles, particle, count = 0;

				var mouseX = 0,
					mouseY = 0;
					//-486, -465
					
				//摄像机
				var lookOvar = 2;

				var windowHalfX = window.innerWidth / lookOvar;
				var windowHalfY = window.innerHeight / lookOvar;
				
				if (scene && renderer && camera) {
					animate();
					return;
				}

				init();
				animate();

				function init() {

					container = self.$refs['LangCanvas'];
					// container = document.createElement('div');
					// document.body.appendChild(container);

					// console.log(container)
					
					mouseX = container.offsetWidth / 3 * -1
					mouseY = container.offsetHeight / 2 * -1

					camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 1, 10000);
					camera.position.z = 1000;

					scene = new THREE.Scene();

					particles = new Array();

					var PI2 = Math.PI * 2;
					var material = new THREE.ParticleCanvasMaterial({

						color: '#888888',
						program: function(context) {

							context.beginPath();
							context.arc(0, 0, 1, 0, PI2, true);
							context.fill();

						}

					});

					var i = 0;

					for (var ix = 0; ix < AMOUNTX; ix++) {

						for (var iy = 0; iy < AMOUNTY; iy++) {

							particle = particles[i++] = new THREE.Particle(material);
							particle.position.x = ix * SEPARATION - ((AMOUNTX * SEPARATION) / 2);
							particle.position.z = iy * SEPARATION - ((AMOUNTY * SEPARATION) / 2);
							scene.add(particle);

						}

					}

					renderer = new THREE.CanvasRenderer();
					// renderer.setSize(window.innerWidth, window.innerHeight);
					renderer.setSize(container.offsetWidth, container.offsetHeight);
					container.appendChild(renderer.domElement);

					document.getElementById("Lang").addEventListener('mousemove', onDocumentMouseMove, false);
					// document.addEventListener('touchstart', onDocumentTouchStart, false);
					// document.addEventListener('touchmove', onDocumentTouchMove, false);

					//

					window.addEventListener('resize', onWindowResize, false);

				}
				
				var langCanvasLoad = setInterval(() => {
					// console.log(self.langCanvasLoad)
					if (self.langCanvasLoad) {
						onWindowResize();
						clearInterval(langCanvasLoad);
					}
				}, 1000);

				function onWindowResize() {

					windowHalfX = window.innerWidth / lookOvar;
					windowHalfY = window.innerHeight / lookOvar;
					
					mouseX = container.offsetWidth / 3 * -1
					mouseY = container.offsetHeight / 2 * -1
					
					camera.aspect = window.innerWidth / window.innerHeight;
					camera.updateProjectionMatrix();

					renderer.setSize(container.offsetWidth, container.offsetHeight);

				}

				//

				function onDocumentMouseMove(event) {

					mouseX = event.clientX / 3 - windowHalfX;
					mouseY = event.clientY / 2 - windowHalfY * 1.2;
					
					// console.log(mouseX, mouseY)

				}

				function onDocumentTouchStart(event) {

					if (event.touches.length === 1) {

						event.preventDefault();

						mouseX = event.touches[0].pageX - windowHalfX;
						mouseY = event.touches[0].pageY - windowHalfY;

					}

				}

				function onDocumentTouchMove(event) {

					if (event.touches.length === 1) {

						event.preventDefault();

						mouseX = event.touches[0].pageX - windowHalfX;
						mouseY = event.touches[0].pageY - windowHalfY;

					}

				}

				//

				function animate() {

					// requestAnimationFrame(animate);
					// self.remove()
					self.interval = setInterval(() => {
						render()
					}, 20)

					render();


				}

				function render() {

					camera.position.x += (mouseX - camera.position.x) * .05;
					camera.position.y += (-mouseY - camera.position.y) * .05;
					camera.lookAt(scene.position);

					var i = 0;

					for (var ix = 0; ix < AMOUNTX; ix++) {

						for (var iy = 0; iy < AMOUNTY; iy++) {

							particle = particles[i++];
							particle.position.y = (Math.sin((ix + count) * 0.3) * 45) + (Math.sin((iy + count) * 0.5) * 45);
							// particle.scale.x = particle.scale.y = ( Math.sin( ( ix + count ) * 0.3 ) + 1 ) * 2 + ( Math.sin( ( iy + count ) * 0.5 ) + 1 ) * 2;
							particle.scale.x = particle.scale.y = 2 // 点大小
						}

					}

					renderer.render(scene, camera);

					count += 0.03;//速度

				}
			}
		}
	}
</script>

<style>
</style>
